module.exports = __webpack_public_path__ + "img/2.576ca532.png";